import { Vue,Prop,Watch,Component} from 'vue-property-decorator';
import {notificationSubscriberList ,notificationStatusByTotalStaff} from "@/types/Component";

@Component({

})
   
export default class NotificationStaffTotalModal extends Vue {

    @Prop({ default: null })
    private subscriptionId!: string

   @Prop() isShowNotificationTotalStaffModal!: boolean

   @Prop({ default: null })
    subscriberDetails!: notificationSubscriberList[];

   baseUrl = "/notificationStatus";
   notificationStatusByTotalStaff =[] as notificationStatusByTotalStaff [];
   private sortByUserNameASC = false
   private sortByAuthorityASC = false
   private sortByReadStatusASC = false
   private sortByUnReadStatusASC = false

   closeModal(){
    this.$emit('update:isShowNotificationTotalStaffModal', false);
   }

    @Watch('isShowNotificationTotalStaffModal')
    private async onChangeShowNotificationTotalstaffModal(){
        if(this.isShowNotificationTotalStaffModal && this.subscriptionId !=null){
         await this.getNotificationTotalStaffCount()
        }
    }

   private async getNotificationTotalStaffCount(){
   const tenantId = this.subscriptionId;
  const notificationDetailsByStaff = await this.$apiClient.doRequest('get', `${this.baseUrl}/notification_status_staff_total/${tenantId}/`)
        .then((res)=>{
       this.notificationStatusByTotalStaff = res.notificationStatusByTotalStaff
        })
      }

      sortByUserName(isSwitchAsc?: boolean) {
        this.sortByUserNameASC = isSwitchAsc ? !this.sortByUserNameASC : this.sortByUserNameASC
        this.notificationStatusByTotalStaff.sort((a :any, b:any) => {
            const valueA = a.staffName;
            const valueB = b.staffName;
            return this.sortByUserNameASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
  
        })
      }
  
      sortByAuthority(isSwitchAsc?: boolean) {
        this.sortByAuthorityASC = isSwitchAsc ? !this.sortByAuthorityASC : this.sortByAuthorityASC
        this.notificationStatusByTotalStaff.sort((a:any, b:any) => {
            const valueA = a.authority;
            const valueB =b.authority;
            return this.sortByAuthorityASC ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA)
        })
      }

      sortByReadCountAsc(isSwitchAsc?: boolean) {
        this.sortByReadStatusASC = isSwitchAsc ? !this.sortByReadStatusASC : this.sortByReadStatusASC;
        this.notificationStatusByTotalStaff.sort((a: any, b: any) => {
          const countA = a.notificationStatusReadCount || 0;
          const countB = b.notificationStatusReadCount || 0; 
      
          return this.sortByReadStatusASC ? countA - countB : countB - countA;
        });
      }

      sortByUnReadCountAsc(isSwitchAsc?: boolean) {
        this.sortByUnReadStatusASC = isSwitchAsc ? !this.sortByUnReadStatusASC : this.sortByUnReadStatusASC;
        this.notificationStatusByTotalStaff.sort((a: any, b: any) => {
          const countA = a.notificationStatusUnreadCount || 0;
          const countB = b.notificationStatusUnreadCount || 0; 
      
          return this.sortByUnReadStatusASC ? countA - countB : countB - countA;
        });
      }
    }